import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { toast } from 'react-toastify';

const MASTERS = [
  { key:'shippers', label:'Shippers / Suppliers', fields:[{k:'name',l:'Name',req:true},{k:'contact_person',l:'Contact Person'},{k:'country',l:'Country'},{k:'email',l:'Email'},{k:'phone',l:'Phone'}] },
  { key:'cha', label:'CHA Agents', fields:[{k:'name',l:'Name',req:true},{k:'contact_person',l:'Contact'},{k:'email',l:'Email'},{k:'phone',l:'Phone'},{k:'address',l:'Address'}] },
  { key:'shipping-lines', label:'Shipping Lines', fields:[{k:'name',l:'Name',req:true}] },
  { key:'quality-grades', label:'Quality Grades', fields:[{k:'grade',l:'Grade',req:true},{k:'description',l:'Description'}] },
  { key:'origin-countries', label:'Origin Countries', fields:[{k:'country_name',l:'Country Name',req:true}] },
  { key:'icd-locations', label:'ICD Locations', fields:[{k:'location_name',l:'Location Name',req:true},{k:'address',l:'Address'}] },
];

export default function MasterData() {
  const [tab, setTab] = useState('shippers');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  const meta = MASTERS.find(m => m.key === tab);

  const load = () => {
    setLoading(true);
    api.get(`/masters/${tab}`).then(r => { setItems(r.data); setLoading(false); });
  };

  useEffect(() => { load(); }, [tab]);

  const openNew = () => { setForm({}); setModal('new'); };
  const openEdit = (item) => { setForm({...item}); setModal('edit'); };

  const save = async e => {
    e.preventDefault(); setSaving(true);
    try {
      if (modal === 'new') await api.post(`/masters/${tab}`, form);
      else await api.put(`/masters/${tab}/${form.id}`, form);
      toast.success('Saved'); setModal(null); load();
    } catch(err) { toast.error(err.response?.data?.message || 'Save failed'); }
    finally { setSaving(false); }
  };

  const deactivate = async (id) => {
    if (!window.confirm('Deactivate this item?')) return;
    try { await api.delete(`/masters/${tab}/${id}`); toast.success('Deactivated'); load(); }
    catch { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="page-header">
        <div><h2>Master Data</h2><p>Manage reference data used across the system</p></div>
        <button className="btn btn-primary" onClick={openNew}>+ Add {meta?.label}</button>
      </div>

      <div className="tabs">
        {MASTERS.map(m => <div key={m.key} className={`tab${tab===m.key?' active':''}`} onClick={()=>setTab(m.key)}>{m.label}</div>)}
      </div>

      <div className="card" style={{padding:0}}>
        {loading ? <div className="loading">Loading...</div> : items.length === 0 ? <div className="empty-state">No {meta?.label} found</div> :
          <div className="table-wrap">
            <table>
              <thead><tr>
                {meta?.fields.map(f => <th key={f.k}>{f.l}</th>)}
                <th>Actions</th>
              </tr></thead>
              <tbody>
                {items.map(item => (
                  <tr key={item.id}>
                    {meta?.fields.map(f => <td key={f.k}>{item[f.k]||'—'}</td>)}
                    <td>
                      <div className="btn-group">
                        <button className="btn btn-outline btn-xs" onClick={()=>openEdit(item)}>Edit</button>
                        <button className="btn btn-danger btn-xs" onClick={()=>deactivate(item.id)}>Deactivate</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
      </div>

      {modal && (
        <div className="modal-overlay" onClick={()=>setModal(null)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <h3>{modal==='new'?'Add':'Edit'} {meta?.label}</h3>
              <button className="btn-icon" onClick={()=>setModal(null)}>✕</button>
            </div>
            <form onSubmit={save}>
              {meta?.fields.map(f => (
                <div key={f.k} className="form-group">
                  <label>{f.l}{f.req&&<span className="req"> *</span>}</label>
                  <input className="form-control" value={form[f.k]||''} onChange={e=>setForm({...form,[f.k]:e.target.value})} required={f.req} />
                </div>
              ))}
              <div className="btn-group mt-2">
                <button className="btn btn-primary" type="submit" disabled={saving}>{saving?'Saving...':'Save'}</button>
                <button className="btn btn-secondary" type="button" onClick={()=>setModal(null)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
